import { statuses } from '@/returns/constants'

const useLineItemToValidate = ({ lineItem, showLineItemOptions = true }) => {
  const shouldShowLineItemOptions =
    [statuses.rejected, statuses.forReview].includes(lineItem.newStatus) && showLineItemOptions

  const isActive = status => lineItem.newStatus === status

  const getLineItemReason = () => {
    if (lineItem.newStatus === statuses.rejected) {
      return lineItem.reject_reason
    } else if (lineItem.newStatus === statuses.forReview) {
      return lineItem.for_review_reason
    }
  }

  const getLineItemNotes = () => {
    if (lineItem.newStatus === statuses.rejected) {
      return lineItem.reject_reason_text || ''
    } else if (lineItem.newStatus === statuses.forReview) {
      return lineItem.for_review_reason_text || ''
    }
  }

  return { shouldShowLineItemOptions, isActive, lineItemReason: getLineItemReason(), lineItemNotes: getLineItemNotes() }
}

export default useLineItemToValidate
